import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, AutoComplete, Select } from "antd";
import TextArea from "antd/es/input/TextArea";

function Messages() {
  const [options, setOptions] = useState([]);
  const [users, setUsers] = useState([]);
  const [desc, setDesc] = useState("");
  const [messages, setMessages] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "http://78.186.196.90:8091/User/GetAllUser?userId=1&role=teacher"
      );
      setUsers(response.data.users);
      setOptions(
        response.data.users.map((user) => ({
          value: user.title,
          key: user.id,
        }))
      );
    };
    fetchData();
  }, []);

  const handleChangeDesc = (e) => {
    setDesc(e.currentTarget.value);
  };

  const getFullDate = (date) => {
    const dateAndTime = date.split("T");
    return dateAndTime[0].split("-").reverse().join("-");
  };

  const fetchComments = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const response = await axios.get(
      "http://78.186.196.90:8091/Mesages/Get?userId=" + user.id
    );
    setMessages(response.data);
    setSelectedUserId(0);
  };

  useEffect(() => {
    fetchComments();
  }, []);
  const columns = [
    {
      title: "Created Date",
      dataIndex: "createdDate",
      className: "text-xs",
      defaultSortOrder: "ascend",
      width: "20%",
      sorter: (a, b) => a.createdDate - b.createdDate,
      sortDirections: ["ascend", "descend"],
      render: (date) => getFullDate(date),
    },
    {
      title: "From",
      dataIndex: "fromUserName",
      defaultSortOrder: "ascend",
      className: "capitalize",
      width: "20%",
      sorter: (a, b) => a.fromUserName > b.fromUserName,
    },
    {
      title: "To",
      dataIndex: "toUserName",
      defaultSortOrder: "ascend",
      className: "capitalize",
      width: "20%",
      sorter: (a, b) => a.toUserName > b.toUserName,
    },
    {
      title: "Message",
      dataIndex: "message",
      defaultSortOrder: "ascend",
      className: "capitalize",
      sorter: (a, b) => a.message > b.message,
    },
  ];

  const handleSave = () => {
    console.log("SELECTED ", selectedUserId);
    const student = users.filter((x) => x.id === selectedUserId);
    const studentName = student.map((x) => x.title)[0];
    const user = JSON.parse(localStorage.getItem("user"));
    axios
      .post("http://78.186.196.90:8091/Mesages/Add", {
        fromUserId: user.id,
        fromUserName: user.username,
        toUserId: selectedUserId,
        toUserName: studentName,
        message: desc,
      })
      .then(function (response) {
        fetchComments();
        setSelectedUserId(0);
        alert("Message sent successfully!");
      })
      .catch(function (error) {});
  };

  const handleSelectUser = (val, option) => {
    setSelectedUserId(option.key);
  };

  const onChangeTable = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  return (
    <>
      <main>
        <header>
          <div className="flex-row">
            <div>
              <h1>Messages</h1>
              <p>This screen provides messaging between users in the system.</p>
            </div>
            <Button type="primary" onClick={handleSave}>
              Send
            </Button>
          </div>
        </header>

        <div className="flex-row flex-start">
          <section className="one-third">
            <header>
              <h2>New Message</h2>
            </header>

            <div>
              <label className="label">To</label>
              <AutoComplete
                placeholder="To"
                className="input"
                options={options}
                onSelect={(val, option) => handleSelectUser(val, option)}
                filterOption={(val, option) =>
                  option.value.toUpperCase().indexOf(val.toUpperCase()) !== -1
                }
              />
            </div>
            <div>
              <label className="label">Message</label>
              <TextArea
                rows={4}
                placeholder=""
                onChange={handleChangeDesc}
                className="input"
                value={desc}
              />
            </div>
          </section>
          <section className="two-third">
            <header>
              <h2>Messages</h2>
            </header>
            <Table
              rowKey="id"
              columns={columns}
              dataSource={messages}
              rowClassName="table-row"
              onChange={onChangeTable}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
            />
          </section>
        </div>
      </main>
    </>
  );
}

export default Messages;
